import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyBl8hWap8jDU2Vvh6SfKvDNwx580TTF77s',
  authDomain: 'ideally-project-management.firebaseapp.com',
  projectId: 'ideally-project-management',
  storageBucket: 'ideally-project-management.appspot.com',
  messagingSenderId: '54847902691',
  appId: '1:54847902691:web:cfc0297c1359601bd006d6',
};

initializeApp(firebaseConfig);

const db = getFirestore();
const auth = getAuth();
const storage = getStorage();

export { db, auth, storage };
